import camelcaseKeys from "camelcase-keys";
import {
  blockUser,
  onChangePassword,
  onDeleteUser,
  onDeleteUserAccount,
  onGetPage,
  onGetUserByWorkspace,
  onGetUserDetail,
  onGetUserOnlinePage,
  onSendResetPasswordLink,
  onSignOutByAdmin,
  onSignUp,
  onVerifyAccount,
  onVerifyDeleteUserAccount,
  updateInfo,
} from "services/apis/user";
import snakecaseKeys from "snakecase-keys";

import { getMe, logout } from "./auth";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

import { STORAGE_KEYS } from "constants/appConstant";
import StorageHelper from "utils/storeHelper";

export const doDeleteUserAccount = createAsyncThunk(
  "user/doDeleteUserAccount",
  async params => {
    const result = await onDeleteUserAccount(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doVerifyDeleteUserAccount = createAsyncThunk(
  "user/doVerifyDeleteUserAccount",
  async params => {
    const result = await onVerifyDeleteUserAccount(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doGetUserInfo = createAsyncThunk(
  "user/doGetUserInfo",
  async params => {
    const result = await onGetUserDetail(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doGetUserByWorkspace = createAsyncThunk(
  "user/doGetUserByWorkspace",
  async params => {
    const result = await onGetUserByWorkspace(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const signUp = createAsyncThunk(
  "user/signUp",
  async (params, { dispatch }) => {
    const result = await onSignUp(params);
    if (!result) {
      return;
    }
    const res = camelcaseKeys(result.data);
    if (res && res.authToken) {
      StorageHelper.setCookie(STORAGE_KEYS.token, res.authToken, {
        maxAge: res.expireTime,
      });
      dispatch(getMe());
    }

    return result;
  }
);

export const doVerifyAccount = createAsyncThunk(
  "user/doVerifyAccount",
  async params => {
    const result = await onVerifyAccount(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const updateUserInfo = createAsyncThunk(
  "user/updateInfo",
  async (params, { dispatch }) => {
    const request = snakecaseKeys(params);
    const result = await updateInfo(request);
    if (!result) {
      return;
    }
    if (result.status === 200) {
      dispatch(getMe());
    }
    return result;
  }
);

export const doUpdateUserDetail = createAsyncThunk(
  "user/doUpdateUserDetail",
  async params => {
    const request = snakecaseKeys(params);
    const result = await updateInfo(request);
    if (!result) {
      return;
    }
    return result;
  }
);

export const changePassword = createAsyncThunk(
  "user/change-password",
  async (params, { dispatch }) => {
    const request = snakecaseKeys(params);
    const result = await onChangePassword(request);
    if (!result) {
      return;
    }
    if (result.status === 200) {
      dispatch(logout());
    }
    return result;
  }
);

export const getUserPage = createAsyncThunk(
  "user/getUserPage",
  async (params, { dispatch }) => {
    const request = params;

    Object.keys(request).forEach(
      k =>
        (request[k] =
          typeof request[k] == "string"
            ? request[k].trim().replaceAll(/"/g, '"').replaceAll(/\\/g, "\\\\")
            : request[k])
    );

    // remove workspaceId from request
    if (!request.workspaceId) {
      delete request.workspaceId;
    }
    const result = await onGetPage(request);
    if (!result) {
      return;
    }
    dispatch(setNumberOfElements(result.numberOfElements));
    return result;
  }
);

export const getUserOnlinePage = createAsyncThunk(
  "user/getUserOnlinePage",
  async (params, { dispatch }) => {
    const request = params;

    Object.keys(request).forEach(
      k =>
        (request[k] =
          typeof request[k] == "string"
            ? request[k].trim().replaceAll(/"/g, '"').replaceAll(/\\/g, "\\\\")
            : request[k])
    );

    // remove workspaceId from request
    if (!request.workspaceId) {
      delete request.workspaceId;
    }
    const result = await onGetUserOnlinePage(request);
    if (!result) {
      return;
    }
    dispatch(setNumberOfElements(result.numberOfElements));
    return result;
  }
);

export const sendResetPasswordLink = createAsyncThunk(
  "user/adminSendResetPasswordLink",
  async id => {
    const result = await onSendResetPasswordLink(id);
    if (!result) {
      return;
    }
    return result;
  }
);
export const doDeleteUser = createAsyncThunk(
  "user/doDeleteUser",
  async params => {
    const result = await onDeleteUser(params);
    if (!result) {
      return;
    }
    return result;
  }
);
export const doSignOutByAdmin = createAsyncThunk(
  "user/doSignOutByAdmin",
  async id => {
    const result = await onSignOutByAdmin(id);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doBlockUser = createAsyncThunk(
  "user/doBlockUser",
  async params => {
    const result = await blockUser(params);
    if (!result) {
      return;
    }
    return result;
  }
);

const initialState = {
  isSaving: false,
  numberOfElements: 0,
  userDetail: {},
  userList: [],
};

const slice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setNumberOfElements: (state, action) => {
      state.numberOfElements = action.payload;
    },
  },
  extraReducers: {
    [updateUserInfo.pending]: state => {
      state.isSaving = true;
    },
    [updateUserInfo.fulfilled]: state => {
      state.isSaving = false;
    },
    [updateUserInfo.rejected]: state => {
      state.isSaving = false;
    },
    [changePassword.pending]: state => {
      state.isSaving = true;
    },
    [changePassword.fulfilled]: state => {
      state.isSaving = false;
    },
    [changePassword.rejected]: state => {
      state.isSaving = false;
    },
    [doGetUserInfo.fulfilled]: (state, action) => {
      state.userDetail = action.payload;
    },
    [doGetUserByWorkspace.fulfilled]: (state, action) => {
      state.userList = action.payload.data;
    },
  },
});

const { reducer, actions } = slice;
const { setNumberOfElements } = actions;
export default reducer;

export const isSaving = createSelector(
  state => state.user.isSaving,
  isSaving => isSaving
);

export const numOfEls = createSelector(
  state => state.user.numberOfElements,
  numberOfElements => numberOfElements
);

export const getUserDetail = createSelector(
  state => state.user.userDetail,
  userDetail => userDetail
);

export const getUserList = createSelector(
  state => state.user.userList,
  userList => userList
);
